import { render, staticRenderFns } from "./footerAll.vue?vue&type=template&id=b34bcdb4&"
import script from "./footerAll.vue?vue&type=script&lang=js&"
export * from "./footerAll.vue?vue&type=script&lang=js&"
import style0 from "./footerAll.vue?vue&type=style&index=0&id=b34bcdb4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports